// Footer.js
import './styles.css';

const Footer = () => {

    return (
        <footer className="wrapper">
            <h3>
                <a href="https://junocollege.com/" title="Visit Juno College's Website" target="/_blank">Created at Juno College<br></br>by Charles Wong</a>
            </h3>
        </footer>
    )

}

// Export Footer as default so other components can access it
export default Footer;